import { useRef, useEffect} from 'react';
import { useRecoilState } from 'recoil';
import { ToastMessage as Toast } from 'az-platform-ui';
import { ToastMessage } from '../Recoil-State';

export const ToastAlert = () => {
    const [alert , setAlert ]= useRecoilState(ToastMessage);

    const toast = useRef(null);

    useEffect(()=> {
        if( alert && alert.message) {
           toast.current.show({ 
            severity: alert.severity, 
            summary: ' ',
            sticky: true,
            life: 2000,
            detail: alert.message
            });
        }
    } , [alert]);
    
    const hideAfterShow =() => setTimeout(()=> toast.current.clear(), 4000);
    const onHideToast = () => setAlert(null);

    return (<Toast ref={toast} onShow ={ hideAfterShow} onHide ={onHideToast} icon = {' '} className ='hide-icon' />)
}